import React, { useState, useEffect } from 'react';
import Showcase from "./Showcase";
import LatestInsight from './LatestInsights';
import FocusArea from './FocusArea';
import About from './About';
import Infographics from './Infographics';
import ExtractiveData from './ExtrativeData';

const HomePage = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [timeLeft, setTimeLeft] = useState({});

  useEffect(() => {
    const timer = setTimeout(() => setShowBanner(true), 600);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const targetDate = new Date("2030-12-31T23:59:59");
    
    const calculate = () => {
      const difference = +targetDate - +new Date();
      let timeLeft = {};

      if (difference > 0) {
        timeLeft = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        };
      }
      return timeLeft;
    };

    const intervalId = setInterval(() => {
      setTimeLeft(calculate());
    }, 1000);

    // Initial calculation
    setTimeLeft(calculate());

    return () => clearInterval(intervalId);
  }, []);

  const TimerUnit = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div className="bg-gradient-to-b from-fig/80 to-fig backdrop-blur-sm px-3 py-2 rounded-lg min-w-[70px] border border-white/10 shadow-[0_4px_15px_rgba(0,0,0,0.5)] relative flex items-center justify-center">
        <span className="text-mustard font-black text-2xl lg:text-3xl leading-none tracking-tight">
          {String(value).padStart(2, '0')}
        </span>
      </div>
      <span className="text-white text-[10px] uppercase font-bold tracking-[0.15em] mt-2">{label}</span>
    </div>
  );

  const Separator = () => (
    <div className="hidden sm:flex flex-col justify-center pb-5 opacity-40">
      <div className="w-1.5 h-1.5 bg-mustard rounded-full mb-1.5"></div>
      <div className="w-1.5 h-1.5 bg-mustard rounded-full"></div>
    </div>
  );

  return (
    <div className="relative">
      <Showcase />
      <LatestInsight />
      <About/>
      <ExtractiveData />
      <FocusArea />
      <Infographics />

      {/* Floating Bottom Banner */}
      <div 
        style={{ zIndex: 100 }}
        className={`fixed bottom-0 left-0 w-full transform transition-transform duration-700 ease-in-out ${showBanner ? 'translate-y-0' : 'translate-y-full'}`}
      >
         <div className="bg-fig w-full py-5 pb-7 md:pb-5 px-6 md:px-12 flex flex-col md:flex-row items-center justify-center md:justify-between shadow-[0_-15px_40px_rgba(0,0,0,0.5)] border-t-4 border-mustard relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-mustard/5 via-transparent to-mustard/5 pointer-events-none" />
            
            <div className="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-12 mb-2 md:mb-0 text-center md:text-left flex-grow justify-center z-10">
               <div className="bg-mustard text-fig font-black px-6 py-2 rounded text-lg lg:text-xl uppercase tracking-widest shadow-xl transform -skew-x-12 ring-4 ring-mustard/20">
                 <span className="inline-block transform skew-x-12">#ZeroFlare2030</span>
               </div>
               
               <div className="flex flex-col lg:flex-row items-center lg:space-x-8 space-y-4 lg:space-y-0">
                 <p className="font-ubuntu font-bold text-lg md:text-xl lg:text-2xl tracking-wide text-white drop-shadow-md">
                   Countdown to Zero Routine Gas Flaring:
                 </p>
                 
                 {timeLeft.days !== undefined ? (
                   <div className="flex items-center space-x-3 sm:space-x-4">
                     <TimerUnit value={timeLeft.days} label="Days" />
                     <Separator />
                     <TimerUnit value={timeLeft.hours} label="Hours" />
                     <Separator />
                     <TimerUnit value={timeLeft.minutes} label="Mins" />
                     <Separator />
                     <TimerUnit value={timeLeft.seconds} label="Secs" />
                   </div>
                 ) : (
                   <div className="bg-mustard px-8 py-3 rounded-full shadow-lg animate-bounce">
                     <span className="text-fig font-black text-xl lg:text-2xl uppercase tracking-widest">Goal Achieved!</span>
                   </div>
                 )}
               </div>
            </div>
            
            <button 
              onClick={() => setShowBanner(false)} 
              className="absolute right-4 top-1/2 -translate-y-1/2 text-white/50 hover:text-mustard focus:outline-none transition-all duration-300 hover:scale-110 z-20"
              aria-label="Close banner"
            >
               <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
            
         </div>
      </div>
    </div>
  );
};

export default HomePage;
